<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_black_big.png" alt="logo图">
    </div>
    <p class="title">睿博信科</p>
    <p class="address_tel_fax">
      <span>地址：广西南宁市西乡塘区滨河路3号同和华彩上湾尚贤阁B座503号</span>
      <span>Tel：13087914127</span>
      <span>Fax：0771-3233289</span>
    </p>
    <p class="email_wx">
      <span>邮箱：zf@nnruibo.cn</span>
      <span><a href="https://beian.miit.gov.cn/">桂ICP备2022010088号</a></span>
    </p>

    <p class="copy">Copyright &copy; 2017 - 2022 广西睿博信息科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue